import { render, staticRenderFns } from "./DeviceStatsPopup.vue?vue&type=template&id=1285907c&scoped=true"
import script from "./DeviceStatsPopup.vue?vue&type=script&lang=ts"
export * from "./DeviceStatsPopup.vue?vue&type=script&lang=ts"
import style0 from "./DeviceStatsPopup.vue?vue&type=style&index=0&id=1285907c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1285907c",
  null
  
)

export default component.exports